import { render } from "./ForcePasswordChange.vue?vue&type=template&id=56477116&scoped=true"
import script from "./ForcePasswordChange.vue?vue&type=script&lang=js"
export * from "./ForcePasswordChange.vue?vue&type=script&lang=js"

import "./ForcePasswordChange.vue?vue&type=style&index=0&id=56477116&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56477116"]])

export default __exports__